"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var useDragAndDrop_1 = __importDefault(require("../../hooks/useDragAndDrop"));
var CircleContainer_1 = __importDefault(require("../CircleContainer"));
var styles_1 = require("./styles");
var MaterialIcon_1 = __importDefault(require("../MaterialIcon"));
var DragAndDropBox = function (_a) {
    var onFiles = _a.onFiles, supportedTypesText = _a.supportedTypesText, clickText = _a.clickText, dragAndDropText = _a.dragAndDropText, isMultiple = _a.isMultiple, inputAccept = _a.inputAccept;
    var dragContainerRef = (0, react_1.useRef)(null);
    var isDragOver = (0, useDragAndDrop_1.default)(dragContainerRef, onFiles).isDragOver;
    var inputRef = (0, react_1.useRef)(null);
    var handleFileInputClick = function () {
        if (inputRef.current) {
            inputRef.current.click();
        }
    };
    var onInputFile = function (e) {
        if (e.target.files) {
            var selectedFiles = e.target.files;
            onFiles(selectedFiles);
            e.target.value = '';
        }
    };
    // Create a descriptive aria-label
    var ariaLabel = "".concat(clickText, " ").concat(dragAndDropText, " - ").concat(supportedTypesText);
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ ref: dragContainerRef, className: isDragOver ? 'drag-over' : '', "aria-label": ariaLabel, role: "button", tabIndex: 0 }, { children: [(0, jsx_runtime_1.jsx)(styles_1.CenterIcon, { children: (0, jsx_runtime_1.jsx)(CircleContainer_1.default, { children: (0, jsx_runtime_1.jsx)(styles_1.IconContainer, { children: (0, jsx_runtime_1.jsx)(MaterialIcon_1.default, { name: "cloud_upload" }) }) }) }), (0, jsx_runtime_1.jsxs)(styles_1.SupportText, { children: [(0, jsx_runtime_1.jsx)(styles_1.Highlight, __assign({ as: "span", onClick: handleFileInputClick }, { children: clickText })), ' ', dragAndDropText] }), (0, jsx_runtime_1.jsx)(styles_1.SubSupportText, __assign({ size: "sm" }, { children: supportedTypesText })), (0, jsx_runtime_1.jsx)("input", { ref: inputRef, type: "file", name: "file", accept: inputAccept, style: { display: 'none' }, onChange: onInputFile, multiple: isMultiple, "data-testid": "drag-and-drop-file-input", "aria-label": ariaLabel })] })));
};
exports.default = DragAndDropBox;
